import { api, csrf } from './client'

export const authApi = {
  me: () => api.get('/admin/me'),
  login: async payload => { await csrf(); return api.post('/admin/login', payload) },
  logout: () => api.post('/admin/logout'),
  profile: payload => api.put('/admin/profile', payload),
  changePassword: payload => api.put('/admin/change-password', payload),
}

export const vehicleApi = {
  list: params => api.get('/vehicles', { params }),
  featured: params => api.get('/vehicles/featured', { params }),
  newArrivals: params => api.get('/vehicles/new-arrivals', { params }),
  one: slug => api.get(`/vehicles/${slug}`),
  related: slug => api.get(`/vehicles/${slug}/related`),
  filters: () => api.get('/vehicle-filters'),
}

export const publicApi = {
  countries: () => api.get('/countries'),
  ports: countryId => api.get(`/countries/${countryId}/ports`),
  shipping: payload => api.post('/shipping/calculate', payload),
  order: payload => api.post('/orders', payload),
  contact: payload => api.post('/contact', payload),
  settings: () => api.get('/site-settings'),
  content: () => api.get('/content'),
  staff: () => api.get('/staff'),
  founders: () => api.get('/founders'),
}

export const adminApi = {
  dashboard: () => api.get('/admin/dashboard'),
  list: (resource, params) => api.get(`/admin/${resource}`, { params }),
  one: (resource, id) => api.get(`/admin/${resource}/${id}`),
  create: (resource, payload, config) => api.post(`/admin/${resource}`, payload, config),
  update: (resource, id, payload) => api.patch(`/admin/${resource}/${id}`, payload),
  createMultipart: (resource, payload) => api.post(`/admin/${resource}`, payload, { headers: { 'Content-Type': 'multipart/form-data' } }),
  updateMultipart: (resource, id, payload) => { payload.append('_method', 'PATCH'); return api.post(`/admin/${resource}/${id}`, payload, { headers: { 'Content-Type': 'multipart/form-data' } }) },
  remove: (resource, id, params) => api.delete(`/admin/${resource}/${id}`, { params }),
  vehicleStatus: (id, payload) => api.patch(`/admin/vehicles/${id}/status`, payload),
  duplicateVehicle: id => api.post(`/admin/vehicles/${id}/duplicate`),
  bulkVehicles: payload => api.post('/admin/vehicles/bulk', payload),
  uploadImages: (id, payload, onUploadProgress) => api.post(`/admin/vehicles/${id}/images`, payload, { onUploadProgress }),
  reorderImages: (id, images) => api.patch(`/admin/vehicles/${id}/images/reorder`, { images }),
  removeImage: id => api.delete(`/admin/vehicle-images/${id}`),
  sendContactEmail: (id, payload) => api.post(`/admin/contacts/${id}/send-email`, payload),
}

export const adminUsersApi = {
  list: () => api.get('/admin/admins'),
  create: payload => api.post('/admin/admins', payload),
  update: (id, payload) => api.patch(`/admin/admins/${id}`, payload),
  resetPassword: (id, payload) => api.put(`/admin/admins/${id}/password`, payload),
  remove: id => api.delete(`/admin/admins/${id}`),
}
